import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-simple-modal',
  templateUrl: './simple-modal.component.html',
  styleUrl: './simple-modal.component.scss'
})
export class SimpleModalComponent {
  @Input() modalId: string = '';
}
